module.exports = __webpack_public_path__ + "img/00591531000104.96a483b3.png";